import musicUrl from './assets/sounds/carlo-cristina-ikaw-at-ako.mp3';

const INVITATION_PATH = '/invitations/custom/carlo-and-cristina-wedding';

const FAQ_ITEMS = [
  {
    icon: '+1',
    question: 'May I invite a “PLUS ONE” to the event?',
    answers: [
      'As much as we would love to accommodate all your friends and family, we have a limited number of guests due to the intimate nature of our celebration and the capacity of our venue.',
      'Please understand that this event is strictly by invitation only and we can only accommodate the number of seat/s indicated in the invitation you have received. We appreciate your understanding!',
    ],
  },
  {
    icon: '✓',
    question: "What if I RSVP’d but cannot attend?",
    answers: [
      'We would love to have you at our wedding, but we understand that there are circumstances beyond our control. However, please let us know as soon as possible so we can reallocate your seat/s.',
    ],
  },
  {
    icon: '?',
    question: 'Do we really need to RSVP? We already said “YES” to the couple.',
    answers: [
      'Yes, please. We will be sending your formal RSVP to consolidate guest details and finalize the headcount for catering and seating purposes.',
    ],
  },
  {
    icon: '▤',
    question: 'Can I sit anywhere at the reception?',
    answers: [
      "We’ve set up the seating arrangement for your convenience, keeping you near friends or those with common interests. Our coordinators will gladly help you find your seat after registration—just let them know!",
    ],
  },
  {
    icon: '⌛',
    question: 'When is the appropriate time to leave?',
    answers: [
      "This event took us months to plan, and we want to celebrate it with the people who are very dear to our hearts. We want you to have fun! Please celebrate with us until the end of the program. We’d love for you to stay for the after-party too!",
    ],
  },
  {
    icon: 'P',
    question: 'Is there parking space available for my car?',
    answers: [
      'Yes, there is parking space for everyone at the venue. However, please take note that slots are on a “first come, first served” basis.',
    ],
  },
];

if (window.location.pathname.includes(INVITATION_PATH)) {
  const audio = new Audio(musicUrl);
  audio.loop = true;
  audio.preload = 'auto';

  const STYLE_ID = 'cc-music-and-hero-enhancements';
  const BUTTON_ID = 'cc-music-toggle';
  let controlsObserver = null;
  let controlsObserverTimeout = null;

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .cc-opening-content {
        width: min(calc(100vw - 48px), 900px) !important;
      }

      .cc-open-name,
      .cc-hero-names {
        white-space: nowrap !important;
      }

      .cc-open-name {
        font-size: clamp(38px, 6vw, 76px) !important;
        letter-spacing: -0.025em;
      }

      .cc-top-controls {
        display: flex !important;
        align-items: center;
        gap: 10px;
      }

      .cc-music-btn {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        padding: 0;
        background: rgba(251, 243, 228, .88);
        border: 1.5px solid rgba(181, 96, 46, .35);
        color: #6b4a30;
        cursor: pointer;
        box-shadow: 0 6px 16px rgba(0, 0, 0, .18);
      }

      .cc-music-btn:focus-visible {
        outline: 3px solid rgba(201, 147, 47, .55);
        outline-offset: 3px;
      }

      .cc-music-play {
        width: 0;
        height: 0;
        margin-left: 3px;
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-left: 11px solid currentColor;
      }

      .cc-music-bars {
        height: 17px;
        display: inline-flex;
        align-items: center;
        gap: 2px;
      }

      .cc-music-bars span {
        width: 3px;
        height: 6px;
        border-radius: 999px;
        background: currentColor;
        transform-origin: center;
        animation: ccMusicBeat .72s ease-in-out infinite;
      }

      .cc-music-bars span:nth-child(2) { animation-delay: -.18s; }
      .cc-music-bars span:nth-child(3) { animation-delay: -.36s; }
      .cc-music-bars span:nth-child(4) { animation-delay: -.54s; }

      @keyframes ccMusicBeat {
        0%, 100% { height: 5px; opacity: .65; }
        50% { height: 17px; opacity: 1; }
      }

      .cc-hero-content {
        max-width: min(94vw, 900px) !important;
        transform: translateY(clamp(68px, 8.5vh, 96px));
      }

      .cc-hero-names {
        font-size: clamp(38px, 7vw, 92px) !important;
        letter-spacing: -0.025em;
      }

      .cc-scroll-hint {
        position: absolute !important;
        left: 50%;
        bottom: clamp(32px, 5vh, 52px);
        width: 32px;
        margin: 0 0 0 -16px !important;
      }

      .cc-faq-card {
        padding: clamp(20px, 4vw, 34px) !important;
        text-align: left !important;
        background: #fffaf3 !important;
        border: 1px solid rgba(122, 79, 51, .16) !important;
        border-radius: 20px !important;
        box-shadow: 0 12px 30px rgba(74, 52, 35, .10) !important;
      }

      .cc-faq-title {
        margin: 0 0 clamp(18px, 3vw, 24px) !important;
        text-align: center;
        color: #6b4a30;
      }

      .cc-faq-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .cc-faq-item {
        overflow: hidden;
        border: 1px solid rgba(140, 91, 53, .22);
        border-radius: 14px;
        background: #fffdf9;
        box-shadow: 0 6px 18px rgba(74, 52, 35, .07);
        transition: box-shadow .35s ease, transform .35s ease;
      }

      .cc-faq-item.is-open {
        box-shadow: 0 10px 24px rgba(74, 52, 35, .12);
      }

      .cc-faq-trigger {
        width: 100%;
        min-height: 58px;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 14px 16px;
        border: 0;
        background: linear-gradient(115deg, #7a4f33 0%, #9a6039 58%, #b56a3d 100%);
        color: #fffaf3;
        cursor: pointer;
        text-align: left;
        font-family: 'Cormorant Garamond', serif;
        font-size: clamp(16px, 2.5vw, 19px);
        font-weight: 700;
        line-height: 1.25;
        transition: filter .25s ease, box-shadow .25s ease;
      }

      .cc-faq-trigger:hover {
        filter: brightness(1.05);
      }

      .cc-faq-trigger:focus-visible {
        position: relative;
        z-index: 1;
        outline: 3px solid rgba(201, 147, 47, .65);
        outline-offset: -3px;
      }

      .cc-faq-icon {
        width: 32px;
        height: 32px;
        flex: 0 0 32px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        color: #7a4f33;
        background: #f8e5c7;
        font-family: Arial, sans-serif;
        font-size: 15px;
        font-weight: 800;
        line-height: 1;
        box-shadow: inset 0 0 0 1px rgba(122, 79, 51, .10);
      }

      .cc-faq-question-text {
        flex: 1 1 auto;
      }

      .cc-faq-chevron {
        width: 24px;
        height: 24px;
        flex: 0 0 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-family: Arial, sans-serif;
        font-size: 20px;
        line-height: 1;
        transform: rotate(0deg);
        transition: transform .42s cubic-bezier(.22, 1, .36, 1);
      }

      .cc-faq-item.is-open .cc-faq-chevron {
        transform: rotate(180deg);
      }

      .cc-faq-answer {
        height: 0;
        overflow: hidden;
        opacity: 0;
        transform: translateY(-6px);
        background: #fffdf9;
        color: #4a3b2d;
        will-change: height, opacity, transform;
        transition:
          height .46s cubic-bezier(.22, 1, .36, 1),
          opacity .28s ease,
          transform .46s cubic-bezier(.22, 1, .36, 1);
      }

      .cc-faq-item.is-open .cc-faq-answer {
        opacity: 1;
        transform: translateY(0);
      }

      .cc-faq-answer-inner {
        overflow: hidden;
      }

      .cc-faq-answer-content {
        padding: 16px 18px 18px;
        border-top: 1px solid rgba(181, 106, 61, .14);
      }

      .cc-faq-answer-content p {
        margin: 0;
        font-size: clamp(14px, 2.1vw, 16px);
        line-height: 1.65;
      }

      .cc-faq-answer-content p + p {
        margin-top: 12px;
      }

      @media (max-width: 640px) {
        .cc-opening-content {
          width: calc(100vw - 28px) !important;
          padding-inline: 0 !important;
        }

        .cc-open-name {
          font-size: clamp(30px, 10.2vw, 50px) !important;
          letter-spacing: -0.045em;
        }

        .cc-hero-content {
          transform: translateY(clamp(58px, 7.5vh, 78px));
        }

        .cc-hero-names {
          font-size: clamp(30px, 10.2vw, 52px) !important;
          letter-spacing: -0.045em;
        }

        .cc-scroll-hint {
          bottom: 24px;
        }

        .cc-faq-card {
          padding: 16px 10px !important;
          border-radius: 16px !important;
        }

        .cc-faq-list {
          gap: 10px;
        }

        .cc-faq-trigger {
          min-height: 54px;
          align-items: flex-start;
          padding: 12px;
          font-size: 16px;
        }

        .cc-faq-icon {
          width: 30px;
          height: 30px;
          flex-basis: 30px;
          font-size: 14px;
        }

        .cc-faq-chevron {
          margin-top: 2px;
        }

        .cc-faq-answer-content {
          padding: 13px 12px 15px;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .cc-music-bars span {
          animation: none;
          height: 11px;
        }

        .cc-faq-item,
        .cc-faq-trigger,
        .cc-faq-chevron,
        .cc-faq-answer {
          transition: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const renderButtonState = (button) => {
    if (!button) return;

    const isPlaying = !audio.paused;
    const nextState = isPlaying ? 'playing' : 'paused';

    button.setAttribute('aria-label', isPlaying ? 'Pause wedding music' : 'Play wedding music');
    button.setAttribute('title', isPlaying ? 'Pause music' : 'Play music');
    button.setAttribute('aria-pressed', String(isPlaying));

    if (button.dataset.musicState === nextState) return;
    button.dataset.musicState = nextState;
    button.innerHTML = isPlaying
      ? '<span class="cc-music-bars" aria-hidden="true"><span></span><span></span><span></span><span></span></span>'
      : '<span class="cc-music-play" aria-hidden="true"></span>';
  };

  const ensureMusicButton = () => {
    const controls = document.querySelector('.cc-top-controls');
    if (!controls) return false;

    let button = document.getElementById(BUTTON_ID);
    if (!button) {
      button = document.createElement('button');
      button.id = BUTTON_ID;
      button.type = 'button';
      button.className = 'cc-music-btn';
      button.addEventListener('click', async () => {
        try {
          if (audio.paused) await audio.play();
          else audio.pause();
        } catch (error) {
          console.warn('Wedding music could not be played:', error);
        }
        renderButtonState(button);
      });
      controls.prepend(button);
    }

    renderButtonState(button);
    return true;
  };

  const setFaqItemState = (item, shouldOpen, immediate = false) => {
    const trigger = item.querySelector('.cc-faq-trigger');
    const answer = item.querySelector('.cc-faq-answer');
    const inner = item.querySelector('.cc-faq-answer-inner');
    if (!trigger || !answer || !inner) return;

    if (immediate) answer.style.transition = 'none';

    if (shouldOpen) {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      answer.setAttribute('aria-hidden', 'false');

      if (immediate) {
        answer.style.height = 'auto';
      } else {
        answer.style.height = '0px';
        void answer.offsetHeight;
        answer.style.height = `${inner.scrollHeight}px`;

        const finishOpen = (event) => {
          if (event.propertyName !== 'height') return;
          answer.removeEventListener('transitionend', finishOpen);
          if (item.classList.contains('is-open')) answer.style.height = 'auto';
        };
        answer.addEventListener('transitionend', finishOpen);
      }
    } else {
      const currentHeight = answer.getBoundingClientRect().height || inner.scrollHeight;
      answer.style.height = `${currentHeight}px`;
      void answer.offsetHeight;

      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      answer.setAttribute('aria-hidden', 'true');
      answer.style.height = '0px';
    }

    if (immediate) {
      window.requestAnimationFrame(() => {
        answer.style.transition = '';
      });
    }
  };

  const ensureGuestFaqs = () => {
    const faqHeading = Array.from(document.querySelectorAll('.cc-card .cc-script'))
      .find((heading) => {
        const text = heading.textContent.trim();
        return text === 'Guest Reminders & FAQs' || text === 'Guest FAQs';
      });
    if (!faqHeading) return false;

    const card = faqHeading.closest('.cc-card');
    if (!card) return false;
    if (card.dataset.faqRendered === 'true') return true;

    card.dataset.faqRendered = 'true';
    card.classList.add('cc-faq-card');
    card.innerHTML = `
      <h3 class="cc-script cc-faq-title">Guest FAQs</h3>
      <div class="cc-faq-list">
        ${FAQ_ITEMS.map((item, index) => {
          const answerId = `cc-faq-answer-${index}`;
          const isOpen = index === 0;
          return `
            <article class="cc-faq-item${isOpen ? ' is-open' : ''}">
              <button
                class="cc-faq-trigger"
                type="button"
                aria-expanded="${String(isOpen)}"
                aria-controls="${answerId}"
              >
                <span class="cc-faq-icon" aria-hidden="true">${item.icon}</span>
                <span class="cc-faq-question-text">${item.question}</span>
                <span class="cc-faq-chevron" aria-hidden="true">⌄</span>
              </button>
              <div class="cc-faq-answer" id="${answerId}" role="region" aria-hidden="${String(!isOpen)}">
                <div class="cc-faq-answer-inner">
                  <div class="cc-faq-answer-content">
                    ${item.answers.map((answer) => `<p>${answer}</p>`).join('')}
                  </div>
                </div>
              </div>
            </article>
          `;
        }).join('')}
      </div>
    `;

    const items = Array.from(card.querySelectorAll('.cc-faq-item'));
    items.forEach((item, index) => setFaqItemState(item, index === 0, true));

    card.querySelectorAll('.cc-faq-trigger').forEach((button) => {
      button.addEventListener('click', () => {
        const currentItem = button.closest('.cc-faq-item');
        if (!currentItem) return;

        const willOpen = !currentItem.classList.contains('is-open');

        items.forEach((item) => {
          if (item !== currentItem && item.classList.contains('is-open')) {
            setFaqItemState(item, false);
          }
        });

        setFaqItemState(currentItem, willOpen);
      });
    });

    return true;
  };

  const syncRenderedInvitation = () => {
    const hasMusicButton = ensureMusicButton();
    const hasFaqs = ensureGuestFaqs();
    return hasMusicButton && hasFaqs;
  };

  const stopWatchingForControls = () => {
    if (controlsObserver) {
      controlsObserver.disconnect();
      controlsObserver = null;
    }
    if (controlsObserverTimeout) {
      window.clearTimeout(controlsObserverTimeout);
      controlsObserverTimeout = null;
    }
  };

  const watchForControls = () => {
    stopWatchingForControls();

    if (syncRenderedInvitation()) return;

    const root = document.getElementById('root') || document.body;
    controlsObserver = new MutationObserver(() => {
      if (syncRenderedInvitation()) stopWatchingForControls();
    });
    controlsObserver.observe(root, { childList: true, subtree: true });

    controlsObserverTimeout = window.setTimeout(stopWatchingForControls, 5000);
  };

  document.addEventListener('click', async (event) => {
    if (event.target.closest('.cc-open-btn')) {
      watchForControls();
      try {
        await audio.play();
      } catch (error) {
        console.warn('Wedding music autoplay was blocked:', error);
      }
    }

    if (event.target.closest('.cc-close-btn')) {
      stopWatchingForControls();
      audio.pause();
      audio.currentTime = 0;
    }
  }, true);

  audio.addEventListener('play', () => renderButtonState(document.getElementById(BUTTON_ID)));
  audio.addEventListener('pause', () => renderButtonState(document.getElementById(BUTTON_ID)));
  audio.addEventListener('ended', () => renderButtonState(document.getElementById(BUTTON_ID)));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureStyles, { once: true });
  } else {
    ensureStyles();
  }
}
